import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { queryClient } from "@/lib/query";

// ponytail: query keys are plain arrays — no separate key-factory; one call site.
function docxQueryKey(documentId: string, versionId?: string) {
  return ["docxBytes", documentId, versionId ?? "current"] as const;
}

export function invalidateDocxBytes(documentId: string, versionId?: string) {
  void queryClient.invalidateQueries({ queryKey: docxQueryKey(documentId, versionId) });
  void queryClient.invalidateQueries({ queryKey: ["pendingEdits", documentId] });
}

export function useFetchDocxBytes(documentId: string, versionId?: string) {
  const { data: bytes, error, isLoading: loading } = useQuery({
    queryKey: docxQueryKey(documentId, versionId),
    queryFn: async () => {
      const response = await api.documents.docxResponse(documentId, versionId);
      if (!response.ok) {
        throw new Error((await response.text()) || `DOCX fetch failed: ${response.status}`);
      }
      return response.arrayBuffer();
    },
    staleTime: Infinity,
    gcTime: 30 * 60_000,
  });

  return {
    bytes: bytes ?? null,
    error: error ? (error instanceof Error ? error.message : "Could not load DOCX bytes.") : null,
    loading,
  };
}
